import type { TCheckoutOutcomeStatus, TSucceededCheckoutEvent, TTerminalCheckoutEvent } from '../types/payment-session.types';

import { env } from '@/config/env';
import type { TCheckoutOutcomeEvent } from '@/features/analytics/public';

export const CHECKOUT_SDK_LABEL = 'UnifiedCheckout';

export const CHECKOUT_SDK_ORIGIN = new URL(env.VITE_UNIFIED_SDK_URL).origin;

// bank_transfer_submitted is a primary LRS rail's only terminal signal; without it those
// investors are stranded on a checkout that will never emit payment.success.
export const CHECKOUT_EVENT_TO_OUTCOME: Record<TTerminalCheckoutEvent, TCheckoutOutcomeStatus> = {
  'payment.success': 'completed',
  'payment.bank_transfer_submitted': 'completed',
  'payment.failure': 'failed',
  'checkout.closed': 'closed',
};

export const SUCCEEDED_CHECKOUT_EVENT_TO_OUTCOME_EVENT: Record<TSucceededCheckoutEvent, TCheckoutOutcomeEvent> = {
  'payment.success': 'payment_success',
  'payment.bank_transfer_submitted': 'bank_transfer_submitted',
};

export const TERMINAL_CHECKOUT_EVENTS = Object.keys(CHECKOUT_EVENT_TO_OUTCOME) as TTerminalCheckoutEvent[];

export const CHECKOUT_DEPENDENCIES_FAILED_EVENT = 'dependencies.failed_to_load' as const;
